import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paging } from '../models/page';
import { Register } from '../models/register';
import { RegisterCloseRequest } from '../models/requests/RegisterCloseRequest';
import { ResponseModel } from '../models/response-model';
import { AutomaticRegisterClosing } from '../models/response/automaticRegisterClosingResponseModel';

import { HasPendingCashDepositPeriodsResponse } from '../models/response/has-pending-cash-deposit-periods-response';
import { RegisterCloseResponse } from '../models/response/registerCloseResponse';
import { UserWithOutRegisterCloseResponseModel } from '../models/response/userWithOutRegisterCloseResponseModel';

import { CreateDailyCashDepositMonitorAccessLogRequest } from '../models/request/create-daily-cash-deposit-monitor-access-log-request';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private url = `${environment.url}/registers`;
  private urlAutomaticRegisterClosing = `${environment.url}/automaticRegisterClosing`;
  constructor(
    private http: HttpClient
  ) { }

  readRegisters(): Observable<ResponseModel<Paging<Array<Register>>>> {
    let params = new HttpParams();
    params = params
      .set("page", "0")
      .set("pageSize", "100000");

    return this.http.get<ResponseModel<Paging<Array<Register>>>>(this.url, { params });
  }

  readRegister(id: string): Observable<ResponseModel<Register>> {
    const path = `${this.url}/${id}`
    return this.http.get<ResponseModel<Register>>(path);
  }

  readRegisterClosingFails(page: number, pageSize: number, branchCode: string, status: string, regionCodes: string): Observable<ResponseModel<Paging<Array<AutomaticRegisterClosing>>>> {
    let params = new HttpParams();
    params = params
      .set("page", `${page}`)
      .set("pageSize", `${pageSize}`);

    if (branchCode) {
      params = params.set("branchCode", branchCode);
    }

    if (status) {
      params = params.set("status", status);
    }

    if (regionCodes) {
      params = params.set("regionCode", regionCodes);
    }

    return this.http.get<ResponseModel<Paging<Array<AutomaticRegisterClosing>>>>(this.urlAutomaticRegisterClosing, { params });
  }

  readUsersWithOutRegisterClose(branchCode: string, page: number, pageSize: number): Observable<ResponseModel<Paging<Array<UserWithOutRegisterCloseResponseModel>>>> {
    let url = `${environment.url}/userWithOutRegisterClose/${branchCode}`;

    let params = new HttpParams();
    params = params
      .set("page", `${page}`)
      .set("pageSize", `${pageSize}`);

    if (branchCode) {
      params = params.set("branchCode", branchCode);
    }

    return this.http.get<ResponseModel<Paging<Array<UserWithOutRegisterCloseResponseModel>>>>(url, { params });
  }

  createDailyCashDepositMonitorAccessLog(createDailyCashDepositMonitorAccessLog: CreateDailyCashDepositMonitorAccessLogRequest): Observable<ResponseModel<any>> {
    return this.http.post<ResponseModel<any>>(`${this.url}/createDailyCashDepositMonitorAccessLog`, createDailyCashDepositMonitorAccessLog);
  }

  createRegisterClose(registerCloseRequest: RegisterCloseRequest, registerCode: string) {
    let url = `${environment.url}/registers/${registerCode}/close`;

    return this.http.post<ResponseModel<RegisterCloseResponse>>(url, registerCloseRequest);
  }

  readCashDepositAlarm(registerCode: string, branchCode: string, username?: string): Observable<ResponseModel<HasPendingCashDepositPeriodsResponse>> {
    let params = new HttpParams()
      .set('registerCode', registerCode)
      .set('branchCode', branchCode);

    params = username ? params.set('username', username) : params;

    return this.http
      .get<ResponseModel<HasPendingCashDepositPeriodsResponse>>(`${this.url}/hasCashDepositPending`, { params });

  }
}
